/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListingState } from './ListingState';
import {
    ListingStateFromJSON,
    ListingStateFromJSONTyped,
    ListingStateToJSON,
} from './ListingState';
import type { MlsListingInfo } from './MlsListingInfo';
import {
    MlsListingInfoFromJSON,
    MlsListingInfoFromJSONTyped,
    MlsListingInfoToJSON,
} from './MlsListingInfo';

/**
 * 
 * @export
 * @interface PublicListing
 */
export interface PublicListing {
    /**
     * 
     * @type {string}
     * @memberof PublicListing
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PublicListing
     */
    addressStr: string;
    /**
     * 
     * @type {Array<MlsListingInfo>}
     * @memberof PublicListing
     */
    mlsNames?: Array<MlsListingInfo>;
    /**
     * 
     * @type {Date}
     * @memberof PublicListing
     */
    highestAndBestDeadline?: Date;
    /**
     * 
     * @type {number}
     * @memberof PublicListing
     */
    listPrice?: number;
    /**
     * 
     * @type {ListingState}
     * @memberof PublicListing
     */
    listingStatus?: ListingState;
}

/**
 * Check if a given object implements the PublicListing interface.
 */
export function instanceOfPublicListing(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "addressStr" in value;

    return isInstance;
}

export function PublicListingFromJSON(json: any): PublicListing {
    return PublicListingFromJSONTyped(json, false);
}

export function PublicListingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicListing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'addressStr': json['address_str'],
        'mlsNames': !exists(json, 'mls_names') ? undefined : ((json['mls_names'] as Array<any>).map(MlsListingInfoFromJSON)),
        'highestAndBestDeadline': !exists(json, 'highest_and_best_deadline') ? undefined : (new Date(json['highest_and_best_deadline'])),
        'listPrice': !exists(json, 'list_price') ? undefined : json['list_price'],
        'listingStatus': !exists(json, 'listing_status') ? undefined : ListingStateFromJSON(json['listing_status']),
    };
}

export function PublicListingToJSON(value?: PublicListing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'address_str': value.addressStr,
        'mls_names': value.mlsNames === undefined ? undefined : ((value.mlsNames as Array<any>).map(MlsListingInfoToJSON)),
        'highest_and_best_deadline': value.highestAndBestDeadline === undefined ? undefined : (value.highestAndBestDeadline.toISOString()),
        'list_price': value.listPrice,
        'listing_status': ListingStateToJSON(value.listingStatus),
    };
}

